import React, { useCallback, useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import Header from "../../components/header/Header";
import PageHeading from "../../components/pageHeading/PageHeading";
import Footer from "../../components/footer/Footer";
import "./shareReQuote.scss";
import { CallIcon, LocationIcon } from "../../components/Icons";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { jobId, setLoader } from "../../slice/commonSlice";
import {
  calculateTax,
  calculateTaxByAmount,
  fetchJobDetails,
  fetchProviderAvailability,
  shareFinalQuote,
  shareReQuote,
} from "../../services/auth.service";
import { fetchImage, getFullName, twoDecimalPlaces } from "../../utils/common";

import moment from "moment";
import { toast } from "react-toastify";
import { toast_error, toast_success } from "../../config/Constant";
import { useNavigate } from "react-router-dom";
import { useDropzone } from "react-dropzone";
import InlineItemForm from "./InlineItemForm";
import AlertModel from "../../modals/alertModel/AlertModel";
import UserImg from "../../assets/images/providerProfileImg.png";
const ShareFinalQuote = () => {
  const dispatch = useDispatch();
  const [isSame, setIsSame] = useState(false);
  const [details, setDetails] = useState({});
  const [providerDes, setProviderDes] = useState("");
  const [jobTime, setJobTime] = useState(null);
  let id = useSelector(jobId);

  const [inlineItem, setInlineItem] = useState([]);
  const [calculatedData, setCalculatedData] = useState({});
  const [inlineTotal, setInlineTotal] = useState(null);
  const [itemTotal, setItemTotal] = useState(null);

  const [jobRate, setJobRate] = useState(null);
  const [fixedPrice, setFixedPrice] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [alertModel, setAlertModel] = useState(false);
  const navigate = useNavigate();
  const [profileUrl, setProfileUrl] = useState(null);
  const [files, setFiles] = useState([]);
  const onDrop = useCallback((acceptedFiles) => {
    // Handle the dropped files
    setFiles((prevFiles) => [...prevFiles, ...acceptedFiles]);
  }, []);
  const timeOptions = [
    { id: 1, value: 0.5, label: "30 Minutes" },
    { id: 2, value: 1, label: "1 Hour" },
    { id: 3, value: 1.5, label: "1 Hour 30 Minutes" },
    { id: 4, value: 2, label: "2 Hours" },
    { id: 5, value: 2.5, label: "2 Hours 30 Minutes" },
    { id: 6, value: 3, label: "3 Hours" },
    { id: 7, value: 3.5, label: "3 Hours 30 Minutes" },
    { id: 8, value: 4, label: "4 Hours" },
    { id: 9, value: 4.5, label: "4 Hours 30 Minutes" },
    { id: 10, value: 5, label: "5 Hours" },
    { id: 11, value: 5.5, label: "5 Hours 30 Minutes" },
    { id: 12, value: 6, label: "6 Hours" },
    { id: 13, value: 6.5, label: "6 Hours 30 Minutes" },
    { id: 14, value: 7, label: "7 Hours" },
    { id: 15, value: 7.5, label: "7 Hours 30 Minutes" },
    { id: 16, value: 8, label: "8 Hours" },
    { id: 17, value: 8.5, label: "8 Hours 30 Minutes" },
    { id: 18, value: 9, label: "9 Hours" },
    { id: 19, value: 9.5, label: "9 Hours 30 Minutes" },
    { id: 20, value: 10, label: "10 Hours" },
    { id: 21, value: 10.5, label: "10 Hours 30 Minutes" },
    { id: 22, value: 11, label: "11 Hours" },
    { id: 23, value: 11.5, label: "11 Hours 30 Minutes" },
    { id: 24, value: 12, label: "12 Hours" },
  ];
  const filteredTimeOptions = timeOptions.filter(
    (option) => option.value >= jobTime
  );
  console.log("JobRate=>", jobRate);
  useEffect(() => {
    if (id) {
      fetchJob();
    }
  }, [id]);

  const fetchJob = async () => {
    let payload = {
      id: id,
    };
    await dispatch(setLoader(true));
    try {
      const response = await fetchJobDetails(payload);
      await dispatch(setLoader(false));
      let [job] = response.data?.jobData;
      setDetails(job);
      setCalculatedData({
        charge: job?.calculatedPrice,
        taxAmount: job?.taxAmount,
        total: job?.finalPrice,
      });
      setJobTime(job?.durationUpdated);
      setFixedPrice(job?.calculatedPrice);
      setEndTime(job?.endTime);
      setJobRate(job?.fixedPrice === null ? "hourly" : "fixed");

      if (job?.userId?.profilePic) {
        try {
          const imageUrl = await fetchImage(job.userId.profilePic);
          setProfileUrl(imageUrl);
        } catch (e) {
          console.error(e.message);
        }
      } else {
        setProfileUrl(UserImg);
      }

      const parsedData = JSON.parse(job?.lineItemsData); // Parse the JSON string

      // Calculate the sum of all numeric values
      const calculatedTotal = parsedData.reduce((sum, item) => {
        return (
          sum +
          Object.values(item).reduce(
            (objSum, value) => objSum + Number(value),
            0
          )
        );
      }, 0);

      setItemTotal(calculatedTotal);
    } catch (error) {
      await dispatch(setLoader(false));
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      // if (isSame) {
      //   setCalculatedData({
      //     charge: details?.calculatedPrice,
      //     taxAmount: details?.taxAmount,
      //     total: details?.finalPrice,
      //   });
      // } else {

      console.log("inlineItem?.length", inlineItem?.length);
      if (inlineItem?.length > 0) {
        if (details?.jobType !== "moving" || details?.jobType !== "delivery") {
          if (jobRate === "fixed" && fixedPrice) {
            fetchTaxByAmount(Number(fixedPrice) + inlineTotal);
          } else {
            console.log("inlineTotal================>", inlineTotal);

            fetchTaxByAmount(calculatedData.charge + inlineTotal);
          }
        }
        //  else {
        //   let res;
        //   if (jobRate === "fixed" && fixedPrice) {
        //     res = await fetchTaxByAmount(Number(fixedPrice));
        //   } else {
        //     res = await fetchTax(details?.unitPrice, jobTime);
        //   }
        //   let chargePayload = fixedPrice ? Number(fixedPrice) : res?.charge;
        //   fetchTaxByAmount(chargePayload + inlineTotal);
        // }
      }
      // else {
      //   if (
      //     details?.jobType === "moving" ||
      //     details?.jobType === "delivery"
      //   ) {
      //     if(jobRate === "fixed" && fixedPrice){
      //       fetchTaxByAmount(Number(fixedPrice));
      //     } else {
      //       setCalculatedData({
      //         charge: details?.calculatedPrice,
      //         taxAmount: details?.taxAmount,
      //         total: details?.finalPrice,
      //       });
      //     }
      //   } else {
      //     if (details?.durationExpected != jobTime) {
      //       if (jobRate === "fixed" && fixedPrice) {
      //         fetchTaxByAmount(Number(fixedPrice));
      //       } else {
      //         fetchTax(details?.unitPrice, jobTime);
      //       }
      //     }
      //   }
      // }
      // }
    };
    fetchData();
  }, [inlineTotal]);

  const formatDateTime = (date) => {
    if (date) {
      const inputDate = moment.utc(date); // Parse the date as UTC
      const bermudaDate = inputDate.tz("Atlantic/Bermuda"); // Convert to Bermuda time
      const formattedDate = bermudaDate.format("h:mm A, DD MMMM, YYYY"); // Format the date
      return formattedDate;
    } else {
      return "";
    }
  };

  const handleIsSame = () => {
    if (!isSame) {
      setProviderDes("");
      setJobTime(details?.durationExpected);
      setFixedPrice(null);
      setJobRate(null);
    }
    setIsSame(!isSame);
  };

  //   const handleJobTime = async (val) => {
  //   await dispatch(setLoader(true));
  //   console.log("Input Value (val):", val); // New input duration
  //   console.log("Current Job Time:", jobTime); // Existing job duration

  //   const newDuration = Number(val); // Duration being set
  //   const existingDuration = jobTime || 0; // Existing duration
  //   const durationDiff = newDuration - existingDuration; // How much more we're adding

  //   console.log("Cumulative Job Duration (durationUpdated):", newDuration);
  //   console.log("Updated Job Time:", newDuration);
  //   console.log("Start Time (details?.startTime):", details?.startTime);

  //   const payload = {
  //     date: details?.startTime,
  //     providerId: details?.providerId?._id,
  //     timezoneOffset: -180, // Adjust for Bermuda timezone
  //   };

  //   try {
  //     const response = await fetchProviderAvailability(payload); // Fetch slot availability
  //     const availableSlots = response?.data;

  //     if (!availableSlots) {
  //       console.error("No availability data received.");
  //       await dispatch(setLoader(false));
  //       return;
  //     }

  //     let slotFound = true;
  //     let actualEndTime = null;

  //     const startTime = moment.tz(details?.startTime, "Atlantic/Bermuda"); // Job start time
  //     const newEndTimeMoment = startTime.clone().add(newDuration * 60, "minutes");

  //     if (durationDiff > 0) {
  //       // Only check extra time
  //       const slotCheckStart = startTime.clone().add(existingDuration * 60, "minutes");
  //       console.log("Adjusted Start Time for slot check:", slotCheckStart.format("HH:mm"));

  //       for (let i = 1; i <= durationDiff * 2; i++) {
  //         const slotTime = slotCheckStart.clone().add((i - 1) * 30, "minutes").format("HH:mm");
  //         console.log("Slot all:", availableSlots.data);
  //         console.log(`Checking Slot Time: ${slotTime}`);

  //         if (!(slotTime in availableSlots.data)) {
  //           console.warn(`Slot ${slotTime} not found`);
  //           setAlertModel(true);
  //           slotFound = false;
  //           break;
  //         }

  //         const slotAvailability = availableSlots.data[slotTime];
  //         console.log("Slot availability:", slotAvailability);

  //         if (slotAvailability === 2) {
  //           console.log(`Slot ${slotTime} is already booked.`);
  //           setAlertModel(true);
  //           slotFound = false;
  //           break;
  //         }
  //       }
  //     }

  //     if (slotFound) {
  //       actualEndTime = newEndTimeMoment.format("YYYY-MM-DDTHH:mm:ssZ");
  //       console.log("All new slots are available. Setting End Time:", actualEndTime);

  //       setJobTime(newDuration);
  //       setEndTime(actualEndTime);

  //       if (jobRate === "fixed" && fixedPrice) {
  //         console.log("Fixed==>");
  //         fetchTaxByAmount(Number(fixedPrice));
  //       } else if (details?.unitPrice) {
  //         console.log("NoFixed==>");
  //         fetchTax(details?.unitPrice, newDuration);
  //       }
  //     }
  //   } catch (error) {
  //     console.error("Error fetching provider availability:", error);
  //   } finally {
  //     await dispatch(setLoader(false));
  //   }
  // };

 const handleJobTime = async (val) => {
  await dispatch(setLoader(true));
  console.log("Input Value (val):", val);
  console.log("Current Job Time:", jobTime);

  const durationUpdated = Number(val);
  console.log("Cumulative Job Duration (durationUpdated):", durationUpdated);

  const updatedJobTime = val;
  console.log("Updated Job Time:", updatedJobTime);
  console.log("Start Time (details?.startTime):", details?.startTime);

  const payload = {
    date: details?.startTime,
    providerId: details?.providerId?._id,
    timezoneOffset: -180,
  };

  try {
    const response = await fetchProviderAvailability(payload);
    const availableSlots = response?.data;

    if (!availableSlots) {
      console.error("No availability data received.");
      await dispatch(setLoader(false));
      return;
    }

    let slotFound = false;
    let actualEndTime = null;

    // 🔧 Adjusted logic: compute new startTime for slot check
    const oldStart = moment.tz(details?.startTime, "Atlantic/Bermuda");
    const oldEnd = moment.tz(endTime, "Atlantic/Bermuda");
    const oldMinutes = oldEnd.diff(oldStart, "minutes");
    const newMinutes = Number(val) * 60;
    const extraMinutes = newMinutes - oldMinutes;

    const startTime = oldStart.clone().add(oldMinutes, "minutes"); // Start checking from here
    console.log("Adjusted Start Time for Slot Check:", startTime.format("HH:mm"));
    console.log("Old Duration:", oldMinutes, "mins");
    console.log("New Duration:", newMinutes, "mins");
    console.log("Extra Minutes to Check:", extraMinutes);

    const slotsToCheck = Math.ceil(extraMinutes / 30);

    for (let i = 1; i <= slotsToCheck; i++) {
      const slotTime = startTime.clone().add(i * 30, "minutes").format("HH:mm");
      console.log("Slot all:", availableSlots.data);
      console.log(`Checking Slot Time: ${slotTime}`);

      if (!(slotTime in availableSlots.data)) {
        console.warn(`Slot ${slotTime} is not available in data.`);
        slotFound = false;
        setAlertModel(true);
        return;
      }

      const slotAvailability = availableSlots.data[slotTime];
      console.log("Slot availability:", slotAvailability);

      if (slotAvailability === 2) {
        console.log(`Slot ${slotTime} is already booked.`);
        slotFound = false;
        setAlertModel(true);
        return;
      } else if (slotAvailability === 1 || slotAvailability === 3) {
        console.log(`Slot ${slotTime} is free`);
        slotFound = true;
      }
    }

    if (slotFound) {
      actualEndTime = oldStart
        .clone()
        .add(newMinutes, "minutes")
        .format("YYYY-MM-DDTHH:mm:ssZ");

      console.log("All slots in the range are available. Setting End Time:", actualEndTime);

      setJobTime(updatedJobTime);
      setEndTime(actualEndTime);

      if (jobRate === "fixed" && fixedPrice) {
        console.log("Fixed==>");
        fetchTaxByAmount(Number(fixedPrice));
      } else if (details?.unitPrice) {
        console.log("NoFixed==>");
        fetchTax(details?.unitPrice, updatedJobTime);
      }
    }
  } catch (error) {
    console.error("Error fetching provider availability:", error);
  } finally {
    await dispatch(setLoader(false));
  }
};


  const handleAlertClose = () => {
    setAlertModel(false);
  };

  const fetchTax = async (unitPrice, time) => {
    let payload = {
      unitPrice: unitPrice,
      durationExpected: time,
      inlineTotal: itemTotal,
    };
    await dispatch(setLoader(true));
    try {
      const response = await calculateTax(payload);
      await dispatch(setLoader(false));
      if (response?.data?.status) {
        console.log("inlineItem?.length ", inlineItem?.length);
        if (inlineItem?.length > 0) {
          console.log(" greater than zero");

          setCalculatedData(response.data);
        } else {
          console.log(" less than zero");
          console.log("response.data zero", response.data);
          setCalculatedData(response.data);
        }
      }
    } catch (error) {
      await dispatch(setLoader(false));
      console.error("Error fetching data:", error);
    }
  };

  const fetchTaxByAmount = async (price) => {
    let payload = {
      amount: price,
    };
    await dispatch(setLoader(true));
    try {
      const response = await calculateTaxByAmount(payload);
      await dispatch(setLoader(false));
      setCalculatedData({
        charge: price,
        taxAmount: response?.data?.taxAmount,
        total: response?.data?.finalAmount,
      });
    } catch (error) {
      await dispatch(setLoader(false));
      console.error("Error fetching data:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // if (!jobTime) {
    //   toast.error("Please select job expected time", toast_error);
    //   return;
    // }
    // if (!jobRate) {
    //   toast.error("Please select job price rate", toast_error);
    //   return;
    // }
    // if (jobRate === "fixed" && !fixedPrice) {
    //   toast.error("Please add fiexd price amount", toast_error);
    //   return;
    // }
    let total;
    const formData = new FormData();
    formData.append("jobId", details?._id);
    if (!isSame) {
      formData.append("quoteDescription", providerDes);
      formData.append("lineItemsData", JSON.stringify(inlineItem));
      if (
        inlineItem?.length > 0 ||
        calculatedData?.charge != details?.unitPrice
      ) {
        total = calculatedData?.charge;
        formData.append("updatedTotal", total);
        formData.append("lineItemsTotal", inlineTotal);
      }
      formData.append("durationUpdated", jobTime);
      formData.append("endTime", endTime);

      if (files?.length > 0) {
        files.forEach((file) => {
          formData.append("quoteFiles", file);
        });
      }
      // if (fixedPrice) {
      //   formData.append("fixedPrice", fixedPrice);
      // }
    }
  
    await dispatch(setLoader(true));
    try {
      const response = await shareFinalQuote(formData);
      await dispatch(setLoader(false));
      if (response?.status) {
        toast.success(response?.data?.message, toast_success);
        navigate(-1);
      }
    } catch (error) {
      toast.error(error?.data?.message, toast_error);
      await dispatch(setLoader(false));
      console.error("Error data:", error);
    }
  };
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: "image/*",
    multiple: true,
  });
  const validate = () => {
    if (isSame) {
      return false;
    } else {
      if (!providerDes) {
        return true;
      } else {
        return false;
      }
    }
  };
  return (
    <>
      <Header />
      <PageHeading title="Share Re-Quote" />
      <div className="main-container">
        <div className="share-re-quote-wrapper">
          <div className="share-date-time-wrap">
            <div className="share-date-title">Date & Time:</div>
            <div className="share-date-time">
              {formatDateTime(details?.startTime)}
            </div>
          </div>
          <div className="share-by-wrapper">
            <div className="share-user-wrap">
              <div className="share-user-img-wrap">
                <img src={profileUrl} alt="User" />
              </div>
              <div className="share-service-name">
                <div className="service-name">
                  {details?.serviceId?.name || details?.serviceName}
                </div>
                <div className="service-name-user">
                  {getFullName(
                    details?.userId?.firstName,
                    details?.userId?.lastName
                  )}
                </div>
              </div>
            </div>
            <div className="share-divider"></div>
            <div className="share-location-wrap">
              <div className="share-location">
                <div className="icon-wrap">
                  <LocationIcon />
                </div>
                <div className="share-location-text">
                  {details?.userId?.location ? details?.userId?.location : "NA"}
                </div>
              </div>
              <div className="share-phone">
                <div className="icon-wrap">
                  <CallIcon />
                </div>
                <div className="share-phone-text">
                  {details?.userId?.phone ? details?.userId?.phone : "NA"}
                </div>
                <div></div>
              </div>
            </div>
          </div>
          <div className="job-rate">
            <div>
              <Form.Label>Job Rate</Form.Label>
              <Form.Select
                aria-label="Default select example"
                value={jobRate}
                onChange={(e) => setJobRate(e.target.value)}
                disabled
              >
                <option>Select Job Rate</option>
                <option value="fixed">Fixed</option>
                <option value="hourly">Hourly</option>
              </Form.Select>
            </div>
            {jobRate === "fixed" || details?.fixedPrice != null ? (
              <div className="fixed-rate">
                <Form.Group>
                  <Form.Label>Fixed Price Amount</Form.Label>
                  <Form.Control
                    type="number"
                    name="fixedPrice"
                    placeholder="Fixed Price"
                    value={fixedPrice}
                    onChange={(e) => setFixedPrice(e.target.value)}
                    disabled
                  />
                </Form.Group>
              </div>
            ) : null}
          </div>
          <div className="w-100">
            <Form.Label>User details</Form.Label>
            <Form.Control
              rows={10}
              as="textarea"
              value={details?.jobDetail}
              disabled
              placeholder="User details"
            />
          </div>
          <div className="w-100">
            <div className="d-flex justify-content-between">
              <Form.Label>Provider Details</Form.Label>
              <Form.Check
                type="checkbox"
                id="customer"
                label="Same as customer"
                value={isSame}
                onChange={() => handleIsSame()}
              />
            </div>
            {!isSame ? (
              <Form.Control
                as="textarea"
                value={providerDes}
                onChange={(e) => setProviderDes(e.target.value)}
                rows={10}
                placeholder="Details"
              />
            ) : null}
          </div>

          {details?.jobType !== "moving" && details?.jobType !== "delivery" ? (
            <div className="w-100">
              <Form.Label>Select the job expected time</Form.Label>
              <Form.Select
                aria-label="Default select example"
                value={jobTime}
                onChange={(e) => handleJobTime(e.target.value)}
              >
                <option>Select the job expected time</option>
                {filteredTimeOptions.map((item, index) => (
                  <option key={index} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </Form.Select>
            </div>
          ) : null}
          {alertModel ? (
            <AlertModel
              isConfirm={alertModel}
              handleClose={handleAlertClose}
              text="The time slots are currently unavailable."
            />
          ) : null}

          {!isSame ? (
            <div className="w-100">
              <div className="box-wrapper browse">
                {/* <div><AttachedFileIcon /></div>
              <div>Add attachments</div>
              <Button variant='outline-primary'  >
                Browse
                <input type="file" name="file" />
              </Button> */}
                <div>
                  <div
                    {...getRootProps()}
                    className={`dropzone ${isDragActive ? "active" : ""}`}
                  >
                    <input {...getInputProps()} />
                    <p>Drag & drop some files here, or click to select files</p>
                  </div>
                  {files.length > 0 && (
                    <div>
                      <h4>Selected Files:</h4>
                      <ul>
                        {files.map((file) => (
                          <li key={file.name}>{file.name}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : null}
          {/* {!isSame ? (
            // <div className='w-100'>
            //   {
            //     inputList.map((x, i) => {
            //       return (
            //         <div key={i} className='add-item-row'>
            //           <div className='item-field'>
            //             <Row className='g-3'>
            //               <Col xs={6}>
            //                 <Form.Label>Item Name</Form.Label>
            //                 <Form.Control
            //                   type="text"
            //                   name='itemName'
            //                   placeholder="Item name here"
            //                   value={x.itemName}
            //                   onChange={(e) => handleInputChange(e, i)}
            //                 />
            //               </Col>
            //               <Col xs={6}>
            //                 <Form.Label>Item Price</Form.Label>
            //                 <Form.Control
            //                   type="number"
            //                   name="price"
            //                   value={x.price}
            //                   placeholder="Price here"
            //                   onKeyDown={(e) => handleUpdateInline(e)}
            //                   onChange={(e) => handleInputChange(e, i)}
            //                 />
            //               </Col>
            //             </Row>
            //           </div>

            //           {inputList.length !== 1 &&
            //             <div className='action-btn' onClick={() => handleRemoveClick(i)}>
            //               <RemoveIcon />
            //             </div>}
            //           {inputList.length - 1 === i && <div className='action-btn' onClick={handleAddClick}> <AddIcon /></div>}
            //         </div>
            //       )
            //     })
            //   }
            // </div>
            <InlineItemForm
              lineItemsData={details?.lineItemsData}
              setInlineItem={setInlineItem}
              setInlineTotal={setInlineTotal}
            />
          ) : null} */}
          <InlineItemForm
            lineItemsData={details?.lineItemsData}
            setInlineItem={setInlineItem}
            setInlineTotal={setInlineTotal}
            setItemTotal={setItemTotal}
          />
          {/* <div className='w-100'>
            <div className='add-item-row'>
              <div className='item-field'>
                <Row className='g-3 '>
                  <Col xs={6}> <Form.Label>Item Name</Form.Label>
                    <Form.Control type="text" placeholder="Item name here" /></Col>
                  <Col xs={6}> <Form.Label>Item Price</Form.Label>
                    <Form.Control type="text" placeholder="Price here" /></Col>
                </Row>
              </div>
              <div className='action-btn'>
                <AddIcon />
              </div>
            </div>
          </div> */}

          <div className="payment-detail-wrap">
            <table className="table">
              <tr>
                <td width="800">Amount</td>
                <td width="140">{`${
                  twoDecimalPlaces(calculatedData?.charge)
                    ? `$${twoDecimalPlaces(calculatedData?.charge)}`
                    : "-"
                }`}</td>
              </tr>
              <tr>
                <td>Time</td>
                <td>{`${
                  twoDecimalPlaces(jobTime)
                    ? `${twoDecimalPlaces(jobTime)} hr`
                    : "-"
                }`}</td>
              </tr>
              <tr>
                <td>Helpr app fee & Transaction fee</td>
                <td>{`${
                  twoDecimalPlaces(calculatedData?.taxAmount)
                    ? `$${twoDecimalPlaces(calculatedData?.taxAmount)}`
                    : "-"
                }`}</td>
              </tr>
              <tr>
                <td>Total</td>
                <td>{`${
                  twoDecimalPlaces(calculatedData?.total)
                    ? `$${twoDecimalPlaces(calculatedData?.total)}`
                    : "-"
                }`}</td>
              </tr>
            </table>
          </div>

          <div className="d-grid">
            <Button variant="primary" onClick={handleSubmit}>
              Reshare Final Estimate
            </Button>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ShareFinalQuote;
